var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 106,
    viewBox: "0 0 125 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.56 79.7441C101.56 79.7441 89.9616 103.111 60.9218 103.98C31.8821 104.849 17.929 76.9644 17.929 76.9644C17.929 76.9644 -27.7993 0 62.3722 0C153.59 0 101.56 79.7441 101.56 79.7441Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22617_512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 111,
    height: 104
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.56 79.7441C101.56 79.7441 89.9616 103.111 60.9218 103.98C31.8821 104.849 17.929 76.9644 17.929 76.9644C17.929 76.9644 -27.7993 0 62.3722 0C153.59 0 101.56 79.7441 101.56 79.7441Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22617_512)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0156 74.3751C81.6523 69.2761 85.5673 62.172 87.6079 55.4386C92.6394 42.4507 83.1856 28.7695 69.0578 24.4879C54.93 20.2062 40.9309 29.6548 37.7006 40.3134C35.458 47.7131 35.8777 56.3562 37.3436 63.6858C37.9953 66.9439 39.9693 70.1417 42.9659 72.8697C41.5118 73.3773 40.6532 74.651 40.9228 77.1305C41.4777 82.2338 40.5584 87.3598 39.6204 92.5906C38.1209 100.952 36.5734 109.581 40.9227 118.813C61.5128 123.873 73.8848 122.826 79.294 118.813C85.0536 114.54 83.145 98.88 81.9216 88.8428C81.5432 85.7379 81.2303 83.171 81.2303 81.6457C81.2303 78.332 78.9747 75.3712 77.0156 74.3751Z",
    fill: "url(#paint0_linear_22617_512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9127 71.6563C52.892 71.6471 52.872 71.638 52.8524 71.6291C52.8728 71.6354 52.8928 71.6445 52.9127 71.6563C55.5415 72.8301 67.3448 76.6343 69.4303 75.5266C72.0578 74.131 66.031 81.2922 64.1223 81.8287C60.7551 82.775 59.5122 82.2406 57.2547 80.6605C54.2878 78.5839 53.8333 72.2037 52.9127 71.6563Z",
    fill: "#005C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5122 55.9666C85.3918 53.6595 85.3567 54.0199 87.0549 49.3962C88.7532 44.7724 82.5082 40.9521 79.1045 37.6186C75.7008 34.2851 74.1891 31.0321 64.6367 30.1798C55.0844 29.3276 53.4723 33.0142 50.3552 34.612C47.2381 36.2099 43.405 33.1411 39.5325 43.1889C37.7 48.6986 39.6994 61.2745 43.6747 67.1633C47.65 73.0521 53.8975 75.8487 60.5311 76.6437C65.7946 77.2745 74.6629 74.6803 80.4587 66.5981C82.2451 64.107 83.2321 59.3239 84.5122 55.9666Z",
    fill: "#005C90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.035 57.6782C81.7641 59.667 77.8729 62.0857 73.8542 61.6243C70.8033 61.2741 69.6461 60.028 68.4703 58.7619C67.2559 57.4542 66.0217 56.1251 62.6606 55.7393C59.3177 55.3555 57.8828 56.3654 56.4633 57.3646C55.0736 58.3427 53.6985 59.3105 50.5624 58.9505C45.4905 58.3683 40.711 54.7529 39.0931 53.0338C38.9908 53.9246 38.9755 55.1102 39.1051 56.4814C40.5847 61.7941 43.3552 67.5667 46.4172 70.706C51.385 75.7992 58.0492 77.4472 64.7403 77.0567C70.0494 76.747 78.3473 72.6256 82.6398 63.6459C83.3739 62.1103 83.7401 59.9237 84.035 57.6782Z",
    fill: "#0193D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.585,
    cy: 47.6424,
    rx: 4.22724,
    ry: 5.46215,
    transform: "rotate(1.77097 52.585 47.6424)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5654,
    cy: 50.1283,
    rx: 4.0207,
    ry: 5.19528,
    transform: "rotate(15.2347 74.5654 50.1283)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0173 84.933C15.0175 82.433 11.5175 83.433 15.5175 89.4331C19.4172 95.2828 27.5174 102.933 34.0173 102.933C44.0175 93.9331 40.5173 79.933 41.0173 75.433C31.5175 75.433 31.0174 92.5819 28.794 92.5819C26.5705 92.5819 23.0172 87.4329 19.0173 84.933Z",
    fill: "#005C90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.518 81.4333C108.296 78.6103 113.506 79.1223 110.017 85.4333C106.616 91.5862 97.0174 97.9332 87.5174 98.4332C77.5175 98.9595 86.0173 80.4332 76.5175 74.9334C90.0174 58.9332 88.1108 86.6785 91.0175 85.4333C93.9241 84.188 100.739 84.2562 104.518 81.4333Z",
    fill: "#005C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5583 82.9693C11.8631 81.3456 7.59784 84.4589 4.90744 86.6358C4.90749 89.7934 6.82431 94.4572 10.9188 95.7078C13.1762 96.3973 15.0909 94.5532 16.8331 91.6132C18.9527 88.0366 20.4726 85.244 14.5583 82.9693Z",
    fill: "#005C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30176 81.4646C6.75146 80.4076 5.53406 80.7111 5.73712 83.2867C6.05116 85.3664 8.92509 86.4997 10.9871 87.1604C12.3306 86.9417 13.1451 85.6272 13.2146 83.6156C13.2991 81.1683 10.2396 82.7859 8.30176 81.4646Z",
    fill: "#005C90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.414256 90.6658C-0.683624 88.6729 2.60152 87.8861 4.5978 86.6109C6.57502 85.4861 7.19113 87.8573 6.0593 89.548C4.92747 91.2387 1.49866 92.6342 0.414256 90.6658Z",
    fill: "#005C90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27478 95.7077C0.934664 93.8689 4.87164 92.1811 6.69142 90.6646C8.51124 89.2998 9.42107 91.5745 8.51118 93.3943C7.60128 95.2141 3.59844 97.5238 2.27478 95.7077Z",
    fill: "#005C90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51482 97.8421C4.91667 96.2227 8.43428 95.2027 10.0089 93.433C11.606 91.8132 12.2734 93.2977 11.6436 95.2323C11.0139 97.167 8.09335 99.4418 6.51482 97.8421Z",
    fill: "#005C90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 79.4185C111.789 77.634 116.477 81.0556 119.434 83.4481C119.434 86.9185 117.327 92.044 112.827 93.4185C110.346 94.1762 108.242 92.1495 106.327 88.9185C103.998 84.9876 102.327 81.9185 108.827 79.4185Z",
    fill: "#005C90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.703 77.7648C117.407 76.6031 118.745 76.9366 118.522 79.7674C118.177 82.0529 115.018 83.2985 112.752 84.0246C111.276 83.7843 110.38 82.3396 110.304 80.1288C110.211 77.4392 113.573 79.2169 115.703 77.7648Z",
    fill: "#005C90"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.372 87.8771C125.578 85.6869 121.968 84.8222 119.774 83.4207C117.601 82.1845 116.924 84.7906 118.168 86.6487C119.412 88.5068 123.18 90.0405 124.372 87.8771Z",
    fill: "#005C90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.327 93.4185C123.8 91.3976 119.473 89.5427 117.473 87.876C115.473 86.376 114.473 88.876 115.473 90.876C116.473 92.876 120.872 95.4145 122.327 93.4185Z",
    fill: "#005C90"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.667 95.7643C119.424 93.9844 115.558 92.8635 113.827 90.9185C112.072 89.1383 111.338 90.7698 112.03 92.896C112.723 95.0223 115.932 97.5223 117.667 95.7643Z",
    fill: "#005C90"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22617_512",
    x1: 62.5533,
    y1: 23.4331,
    x2: 62.5533,
    y2: 122.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataDark);
export default __webpack_public_path__ + "static/media/noData_dark.88e8f64b0134aa350ebc77593703cac6.svg";
export { ForwardRef as ReactComponent };